export default __webpack_public_path__ + "static/cifras-42ecf928322dd5f84ea1e3d4e2adc52d.png";